import { ServiceCard } from "@aqar-app/aqar-design-system";
import Link from "next/link";
import services from "./services";
import styles from "./ServicesFees.module.scss";

export default function ServicesFees() {
  return (
    <div className={styles.servicesContainer}>
      <h3 className={styles.header}>اضغط على الخدمة التي ترغب في دفع رسومها</h3>
      <div className={styles.cardsContainer}>
        {services.map((service) => (
          <Link href={service.path} passHref className={styles.cardLink}>
            <ServiceCard
              label={service.name}
              labelClassName={styles.cardLabel}
              className={styles.card}
              iconProps={{ type: service.icon }}
              onClick={() => service.onClick?.()}
            />
          </Link>
        ))}
      </div>
    </div>
  );
}
